import { NgModule } from '@angular/core';
import {
  NgbModule,
  NgbAlertModule,
  NgbDropdownModule,
  NgbPaginationModule,
  NgbTypeaheadModule,
  NgbProgressbarModule
 } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    NgbModule,
    NgbAlertModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    NgbProgressbarModule
  ],
  exports: [
    NgbModule,
    NgbAlertModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    NgbProgressbarModule
  ],
  declarations: []
})

export class NgBootstrapModule { }
